module.exports = __webpack_public_path__ + "767624f65c42b676ed45c2785b71e71e.pdf";